import React, { FC } from 'react';
import { graus, statusCampanha } from 'utils/campanha-utils';
import IconChevron from '../../../assets/img/chevron-white.png';
import IconChevronBlack from '../../../assets/img/chevron.png';
import IconFilter from '../../../assets/img/filter.png';
import IconClean from '../../../assets/img/clean.png';
import {
  FilterStyled,
  ButtonArrowStyled,
  ImageStyled,
  IconFilterStyled,
  ChevronStyled,
  AccordionContainer,
  AccordionStyled,
  AccordionButtonStyled,
  CardStyled,
  ActionsStyled,
  ButtonStyled,
  ButtonConfirmStyled,
  CleanStyled
} from './style';
import CustomSelect from '../selectInput/custom-select';
import { UseCampanhaHook } from 'hooks/campanha-hook';
import { UseCampanhaContext } from 'context/campanha-context';

const CampanhasFilter: FC = () => {

  const { filterOpened } = UseCampanhaContext();

  const {
    onFilterClicked,
    onFilter,
    cleanFilter
  } = UseCampanhaHook();

  const handleClick = event => {
    event.target.classList.toggle('collapsed');
  };

  return (
    <FilterStyled className={filterOpened ? 'opened' : 'closed'}>
      <ButtonArrowStyled onClick={() => onFilterClicked(!filterOpened)}
        className="close-filter"
      >
        <ImageStyled src={IconChevron} />
        <ImageStyled src={IconChevron} />
      </ButtonArrowStyled>

      <AccordionContainer>
        <AccordionStyled key="0" defaultActiveKey="0">
          <CardStyled>
            <CardStyled.Header>
              <AccordionStyled.Toggle
                as={AccordionButtonStyled}
                onClick={handleClick}
                variant="link"
                eventKey="0"
              >
                <IconFilterStyled src={IconFilter} />
                Filtros
              </AccordionStyled.Toggle>
              <ChevronStyled src={IconChevronBlack} alt="Seta" />
            </CardStyled.Header>
            <AccordionStyled.Collapse eventKey="0">
              <CardStyled.Body>
                <CustomSelect
                  options={graus}
                  defaultOption="Grau de ensino"
                  value="grau"
                />

                <CustomSelect
                  options={statusCampanha}
                  defaultOption="Status"
                  value="status"
                />

                <ActionsStyled>
                  <ButtonStyled onClick={() => cleanFilter()}>
                    <CleanStyled src={IconClean} alt="Limpar" />
                    Limpar filtros
                  </ButtonStyled>
                  <ButtonConfirmStyled
                    onClick={() => onFilter()}
                    type="button"
                  >
                    Aplicar Filtros
                  </ButtonConfirmStyled>
                </ActionsStyled>
              </CardStyled.Body>
            </AccordionStyled.Collapse>
          </CardStyled>
        </AccordionStyled>
      </AccordionContainer>
    </FilterStyled>
  );
};

export default CampanhasFilter;
